import { ofType } from "redux-observable";
import { switchMap } from "rxjs/operators";
import { TypeActionShowMe } from "../actionShowMe";
import { pathSelectSimpleHouseInBuildMenu } from "./pathSelectSimpleHouseInBuildMenu";
export var epicMissingWorkers = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionShowMe.MissingWorkers), switchMap(function (action) {
        return pathSelectSimpleHouseInBuildMenu(action, state$, deps);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/missing-workers/epicMissingWorkers.ts
// module id = 2349
// module chunks = 3